import { isDevPreview } from "./devPreview";

// Single source of truth for "should the patient UI render right now?"
// Used by the route guard, the sidebar fork, and any patient-only feature gates.
export function showPatientUI({ isPatient } = {}) {
  return Boolean(isPatient) || isDevPreview("peptide-patient");
}
